import React, { useEffect } from "react"
import { connect } from "react-redux"
import {
  Button,
  Grid2QuestionnaireIntro,
  QuestionnaireActionBtns,
  Text,
  Title,
} from "@thedgbrt/logology-ui-components"
import { useQuestionIntroData } from "./data/useQuestionIntroData"
import { trackSegmentEvent } from "../../helpers/segment"
import { trackAmplitude } from "../../helpers/amplitude"

const Intro = ({ basepath, lastReachedStep, retake, startupName, type }) => {
  useEffect(() => {
    if (retake === true) {
      trackSegmentEvent("track", "Questionnaire retake")
      trackAmplitude("Questionnaire retake")
    }
  }, [retake])

  const { buttonText, title, text } = useQuestionIntroData(startupName)[1]
  return (
    <Grid2QuestionnaireIntro>
      <Title level={2} last={false}>
        {retake ? "Hello again! " : title}
      </Title>
      <Text lead dangerouslySetInnerHTML={{ __html: text }} />
      <QuestionnaireActionBtns>
        {lastReachedStep > 0 ? (
          <>
            {retake ? (
              <Button href={`${basepath}1`}>Retake questionnaire →</Button>
            ) : (
              <Button href={`${basepath}${lastReachedStep}`}>
                Resume to question {lastReachedStep}/16 →
              </Button>
            )}
          </>
        ) : (
          <Button href={`${basepath}1`}>{buttonText}</Button>
        )}
      </QuestionnaireActionBtns>
    </Grid2QuestionnaireIntro>
  )
}

export default connect(({ questionnaire }) => ({
  startupName: questionnaire.startupName,
}))(Intro)
